<template lang="pug">
v-app#ezserv-r
  v-content
    v-container.pa-0(fluid)
      router-view
  v-bottom-navigation(
    v-if="$route.meta.protected",
    active.sync="activeNav",
    :value="showBottomNav",
    color="white",
    background-color="primary",
    dark,
    fixed,
    grow,
    app
  )
    v-btn(v-for="item in bottomMenuItems", :key="item.title", :to="item.path")
      span {{ item.title }}
      v-icon {{ item.icon }}
</template>

<script>
import { storeMixin } from "./mixins/storeMixin.js";

export default {
  name: "app",
  mixins: [storeMixin],
  beforeMount() {
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      this.$store.state.installPrompt = e;
    });
  },
  data: () => ({ showBottomNav: true, drawer: true }),
  methods: {},
  computed: {
    bottomMenuItems() {
      const items = [];
      items.push({ title: "Home", path: "/home", icon: "mdi-home" });
      if (
        this.myFeatures.eligibleFeatures.includes("WORKFLOW") &&
        this.selectedUser &&
        ["GA", "RM", "SS", "SW", "SH"].includes(this.selectedUser.role)
      ) {
        items.push({
          title: "Services",
          path: `/restaurants/${
            this.selectedRestaurant && this.selectedRestaurant.id
          }/services`,
          icon: "mdi-account-group",
        });
      }
      items.push({
        title: "Orders",
        path: `/restaurants/${
          this.selectedRestaurant && this.selectedRestaurant.id
        }/orders`,
        icon: "mdi-view-dashboard",
      });
      if (
        this.myFeatures.eligibleFeatures.includes("INVENTORY") &&
        this.selectedUser &&
        ["GA", "RM", "CC"].includes(this.selectedUser.role)
      ) {
        items.push({
          title: "Inventory",
          path: `/restaurants/${
            this.selectedRestaurant && this.selectedRestaurant.id
          }/inventory`,
          icon: "mdi-format-list-numbered-rtl",
        });
      }
      items.push({
        title: "Reports",
        path: `/restaurants/${
          this.selectedRestaurant && this.selectedRestaurant.id
        }/reports`,
        icon: "mdi-newspaper-variant-multiple",
      });
      return items;
    },
  },
};
</script>

<style>
@import "../node_modules/firebaseui/dist/firebaseui.css";
</style>